export default (closestTo: number): number => {
    const widthTiers = [400, 800, 1280, 1920];
    let closest = Math.max.apply(null, widthTiers);

    for (const widthTier of widthTiers) {
        if (widthTier >= closestTo && widthTier < closest) {
            closest = widthTier;
            break;
        }
    }

    return closest;
};
